// import React, { useState } from 'react';
// import {
//   TrophyOutlined, FireOutlined, WalletOutlined, LineChartOutlined,
//   AimOutlined, SafetyCertificateOutlined, ShareAltOutlined, CheckCircleFilled, LockFilled,
// } from '@ant-design/icons';
// import AchievementModal from './AchievementModal';

// const ICONS = {
//   trophy: TrophyOutlined,
//   fire: FireOutlined,
//   money: WalletOutlined,
//   chart: LineChartOutlined,
//   aim: AimOutlined,
//   shield: SafetyCertificateOutlined,
// };

// function AchievementCard({ a, onOpen }) {
//   const Icon = ICONS[a.icon] || TrophyOutlined;
//   const open = () => { if (a.unlocked) onOpen(a); }; // locked badges don't open

//   return (
//     <div
//       className={`ach-card ${a.unlocked ? 'is-unlocked' : ''}`}
//       role="button"
//       tabIndex={a.unlocked ? 0 : -1}
//       aria-disabled={!a.unlocked}
//       title={a.unlocked ? 'Open certificate' : `Locked: ${a.description}`}
//       onClick={open}
//       onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
//     >
//       {a.unlocked && <span className="ach-card__share"><ShareAltOutlined /></span>}

//       <div className="ach-card__icon"><Icon /></div>
//       <div className="ach-card__title">{a.title}</div>
//       <div className="ach-card__desc">{a.description}</div>

//       <div className="ach-card__bottom">
//         <span className={`ach-status ${a.unlocked ? 'is-on' : ''}`}>
//           {a.unlocked ? <CheckCircleFilled /> : <LockFilled />}
//           {a.unlocked ? 'Unlocked' : 'Locked'}
//         </span>
//       </div>
//     </div>
//   );
// }

// export default function AchievementGrid({ achievements }) {
//   const [selected, setSelected] = useState(null);

//   return (
//     <>
//       <div className="ach-grid">
//         {achievements.map((a) => <AchievementCard key={a.id} a={a} onOpen={setSelected} />)}
//       </div>
//       <AchievementModal achievement={selected} onClose={() => setSelected(null)} />
//     </>
//   );
// }



import React, { useState } from 'react';
import {
  TrophyOutlined, FireOutlined, WalletOutlined, LineChartOutlined,
  AimOutlined, SafetyCertificateOutlined, CrownOutlined, ShareAltOutlined, CheckCircleFilled, LockFilled,
} from '@ant-design/icons';
import AchievementModal from './AchievementModal';

const ICONS = {
  trophy: TrophyOutlined,
  fire: FireOutlined,
  money: WalletOutlined,
  chart: LineChartOutlined,
  aim: AimOutlined,
  shield: SafetyCertificateOutlined,
  medal: CrownOutlined,
};

function AchievementCard({ a, onOpen }) {
  const Icon = ICONS[a.icon] || TrophyOutlined;
  const open = () => { if (a.unlocked) onOpen(a); }; // locked badges don't open

  return (
    <div
      className={`ach-card ${a.unlocked ? 'is-unlocked' : ''}`}
      role="button"
      tabIndex={a.unlocked ? 0 : -1}
      aria-disabled={!a.unlocked}
      title={a.unlocked ? 'Open certificate' : `Locked: ${a.description}`}
      onClick={open}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
    >
      {a.unlocked && <span className="ach-card__share"><ShareAltOutlined /></span>}

      <div className="ach-card__icon"><Icon /></div>
      <div className="ach-card__title">{a.title}</div>
      <div className="ach-card__desc">{a.description}</div>

      <div className="ach-card__bottom">
        <span className={`ach-status ${a.unlocked ? 'is-on' : ''}`}>
          {a.unlocked ? <CheckCircleFilled /> : <LockFilled />}
          {a.unlocked ? 'Unlocked' : 'Locked'}
        </span>
      </div>
    </div>
  );
}

export default function AchievementGrid({ achievements }) {
  const [selected, setSelected] = useState(null);

  return (
    <>
      <div className="ach-grid">
        {achievements.map((a) => <AchievementCard key={a.id} a={a} onOpen={setSelected} />)}
      </div>
      <AchievementModal achievement={selected} onClose={() => setSelected(null)} />
    </>
  );
}